export { default } from './top-rated-category-item';
